import React from 'react';
import type { ElementRef, ElementType, Ref, ReactNode } from 'react';

import { styled, theme } from '@backyard-ui/styles';
import type { StitchesCSS, CSSProperties } from '@backyard-ui/styles';

import styles from './Text.styles';
export interface TextProps {
  /**
   * The CSS `text-align` property
   */
  align?: Omit<CSSProperties['textAlign'], 'start' | 'end'>;

  /**
   * The CSS `color` property
   */
  color?: keyof typeof theme.colors;

  /**
   * Define the heading size
   */
  size?:
    | 'xs'
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | '4xl'
    | '5xl'
    | '6xl';

  /**
   * The CSS `font-weight` property
   */
  isBold?: boolean;

  /**
   * The CSS `text-transform` property
   */
  isCasing?: boolean;

  /**
   * The CSS `font-style` property
   */
  isItalic?: boolean;

  /**
   * Remove the default margin
   */
  noMargin?: boolean;

  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * Render `as` any heading el
   */
  as?: ElementType;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLParagraphElement>;

  /**
   * The heading children
   */
  children: ReactNode;
}

const DEFAULT_TAG = 'p';

const TextEl = styled(DEFAULT_TAG, styles);

const Text = React.forwardRef<ElementRef<typeof DEFAULT_TAG>, TextProps>(
  (props, ref) => {
    return <TextEl ref={ref} {...props} />;
  }
);

Text.displayName = 'Text';

export default Text;
